"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./Text"), exports);
tslib_1.__exportStar(require("./Text.view"), exports);
tslib_1.__exportStar(require("./Text.styles"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Text/index.js
// module id = 1220
// module chunks = 0